import { faCheckCircle, faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import { useThemeClassName } from '../../contexts/ThemeContext';
import Button from '../buttons/Button';

import styles from '../../../styles/items/sport-group-pill.module.scss';

interface SportGroupPillProps {
    className?: string;
    numberClassName?: string;
    iconClassName?: string;
    label?: string;
    answered?: boolean;
    unlocked?: boolean;
    isDark?: boolean;
    onClick?: () => void;
}

function SportGroupPill({
    className = null,
    numberClassName = null,
    iconClassName = null,
    label = null,
    answered = false,
    unlocked = false,
    isDark = false,
    onClick = null,
}: SportGroupPillProps) {
    const themeClassName = useThemeClassName(styles);
    return (
        <Button
            className={classNames([
                styles.container,
                {
                    [styles.unlocked]: unlocked,
                    [styles.answered]: answered,
                    [styles.isDark]: isDark,
                },
                themeClassName,
                className,
            ])}
            onClick={onClick}
        >
            <span className={classNames([styles.number, numberClassName])}>{label}</span>
            <span className={classNames([styles.icon, iconClassName])}>
                <FontAwesomeIcon icon={answered ? faCheckCircle : unlocked ? faLockOpen : faLock} />
            </span>
        </Button>
    );
}

export default SportGroupPill;
